import React from 'react';
import { Container } from 'react-bootstrap';
import Fade from 'react-reveal/Fade';
import AllAchievements from '../fakeData/AllAchievements';
import ProfessionalHighlights from '../fakeData/ProfessionalHighlights';
import './../index.css';

const Achievements = () => {
  return (
    <section
      data-aos='fade-up'
      className='achievements-container'
      name='achievements'
      id='achievements'
    >
      <Container>
        <div className='common mt-5'>
          <h2 className='mainHeader'>Achievements</h2>
          <div className='commonBorder' />
        </div>

        <div className='professional-highlights mb-5'>
          <h3 className='text-center mb-4'>Professional Highlights</h3>
          <div className='row justify-content-center'>
            {ProfessionalHighlights.map((item) => (
              <div className='col-md-6 professional-highlight-item' key={item.id}>
                <p>{item.text}</p>
              </div>
            ))}
          </div>
        </div>

        <h3 className='text-center mb-4'>Academic &amp; Competition Achievements</h3>
        <div className='projects-container'>
          <Fade bottom>
            {AllAchievements.map((item) => (
              <div className='projects' key={item.id}>
                <div className='flip-box'>
                  <div className='flip-box-inner'>
                    <div className='flip-box-front'>
                      <img
                        src={item.imageFront}
                        alt={item.text}
                        className='Achievement-images'
                      />
                    </div>
                    <div className='flip-box-back'>
                      <img
                        src={item.imageBack}
                        alt={item.text}
                        className='Achievement-images'
                      />
                    </div>
                  </div>
                </div>

                <div className='project-links mt-2'>
                  <h3>{item.text}</h3>
                </div>
              </div>
            ))}
          </Fade>
        </div>
      </Container>
    </section>
  );
};

export default Achievements;
